import styled from 'styled-components/macro';
import { Image } from '@yme/atoms/image';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel3, RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
import { CAROUSEL_DEFAULT_CONFIG } from './constants';
export const FeaturesItemCardStyled = styled(FlexWrapper) `
  display: flex;
  flex-direction: column;

  width: ${CAROUSEL_DEFAULT_CONFIG.sm.width};

  ${ADAPTIVE.minWidth.tablet} {
    width: ${CAROUSEL_DEFAULT_CONFIG.md.width};
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: ${CAROUSEL_DEFAULT_CONFIG.lg.width};
  }
`;
export const ImageWrapperStyled = styled.div `
  position: relative;
  overflow: hidden;

  margin-bottom: 16px;
  user-select: none;

  height: ${CAROUSEL_DEFAULT_CONFIG.sm.height};

  ${ADAPTIVE.minWidth.tablet} {
    height: ${CAROUSEL_DEFAULT_CONFIG.md.height};
  }

  ${ADAPTIVE.minWidth.desktop} {
    height: ${CAROUSEL_DEFAULT_CONFIG.lg.height};
  }
`;
export const ImageStyled = styled(Image) `
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 0 50%;
  & img {
    object-fit: cover;
    width: 100%;
    height: auto;
  }
`;
export const DescriptionStyled = styled(RegularTextLevel3) `
  color: ${colorCoreBlack300};
`;
export const HeadingLevel3Styled = styled(HeadingLevel3) `
  ${getTextStyles('Ubuntu', null, 18, 28)}
  font-weight: 500;
  text-transform: none;
`;
